import { render } from "./AssignUsers.vue?vue&type=template&id=4dd3754a&ts=true"
import script from "./AssignUsers.vue?vue&type=script&lang=ts"
export * from "./AssignUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__